import React, { useState } from "react"
import PropTypes from "prop-types"
import { useOutletContext } from "react-router-dom"

import Drawer from "@components/Page/Drawer"
import { useAppContext } from "@components/AppContext"
import { InvestmentForm } from "@components/Domain"
import { InvestmentShape } from "@shapes"

const updateOperation = "investments/UpdateInvestment"

const LABEL_SAVE = "Save"
const LABEL_TITLE = "Edit Investment"


const InvestmentProfileUpdateDrawer = ({ drawer, investment, updateInvestment }) => {
  const [ block, setBlock ] = useState()

  const { identity } = useAppContext()
  const { organization } = identity

  const { getProject } = useOutletContext()
  const { projectId } = investment

  const project = getProject(projectId)
  const { tiers } = project

  const isTypeSelectDisabeled = true

  const onAfterSubmit = updatedInvestment => {
    updateInvestment(updatedInvestment)
    drawer.current.close()
  }

  const investmentFormProps = {
    submitLabel: LABEL_SAVE,
    tiers,
    block,
    setBlock,
    investment,
    organization,
    onAfterSubmit,
    updateOperation,
    isTypeSelectDisabeled,
  }

  return (
    <Drawer
      title={LABEL_TITLE}
      drawer={drawer}
    >
      <InvestmentForm {...investmentFormProps} />
    </Drawer>
  )
}

InvestmentProfileUpdateDrawer.propTypes = {
  drawer: PropTypes.shape({}).isRequired,
  investment: InvestmentShape.isRequired,
  updateInvestment: PropTypes.func.isRequired,
}

export default InvestmentProfileUpdateDrawer
